// pages/+Page.tsx
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
import HomeLander from "@fableous/ui/containers/HomeLander";

function Page() {
	return (
		<OpenRoute>
			<HomeLander />
		</OpenRoute>
	);
}

export { Page };
